import { defaultSortOptions, sortConfig } from "./sortConfig";

export const mapDisplaySortToState = displaySort => {
  let sortConfigOptions = sortConfig.find(({ value }) => displaySort === value);

  if (!sortConfigOptions) {
    sortConfigOptions = defaultSortOptions;
  }

  return {
    sort: sortConfigOptions.sort,
    sortOrder: sortConfigOptions.sortOrder
  };
};
